<template>
  <q-page class="app-page">
    <div class="app-page-filters">
      <q-form ref="filtersForm" @reset="onResetFilters" @submit="onSubmintFilters">
        <div class="app-page-filters-form">
          <i-field v-model.trim="filters.model.name" field-type="text" label="采血点名称" prepend-icon="place"/>
        </div>
      </q-form>
    </div>
    <div class="app-page-toolbar">
      <i-btn color="action-get" icon="search" @click="search">查询</i-btn>
      <i-btn color="action-reset" icon="undo" label="重置" tooltip-text="重置查询条件" @click="$refs.filtersForm.reset()" />
      <i-btn color="action-add" icon="note_add" @click="add">新增</i-btn>
    </div>
    <div class="app-page-main" id="tabMain">
      <i-table ref="main" :data="main.data" :columns="main.columns" selection="none" :pagination.sync="main.pagination"
        :loading="main.loading" @request="onMainRequest">
        <template v-slot:body-cell-state="props">
          <q-td :props="props">
            <span style="font-size: 16px;" :class="{ open: props.value ? true : false }">{{ props.value ? '启用' : '停用' }}</span>
          </q-td>
        </template>
        <template v-slot:body-cell-operate="props">
          <q-td :props="props">
            <span class="operate-btn" @click="editRow(props.row)">编辑</span>
            <span class="operate-btn" @click="editState(props.row)">{{ props.row.state ? '停用' : '启用' }}</span>
            <!-- <span class="operate-btn" @click="resetPassword">重置密码</span> -->
          </q-td>
        </template>
      </i-table>
    </div>
    <q-dialog v-model='dialogs.edit.show' persistent>
      <b-collect-point-details @saved="onSave" @cancel="dialogs.edit.show=false" :editModel="dialogs.edit.editModel" :mode="dialogs.edit.mode" />
    </q-dialog>
  </q-page>
</template>
<script>
import utils from '@/lib/utils'
import { AppPageMixin } from '@/lib/mixins'
import { BloodType, ComponentType, CollectMethods } from '@/lib/enums'
import BCollectPointDetails from './BCollectPointDetails.vue'

export default {
  mixins: [AppPageMixin],
  components: {
    BCollectPointDetails
  },
  data () {
    return {
      filters: {
        model: {
          name: ''
        }
      },
      main: {
        loading: false,
        data: [],
        columns: [
          { name: 'name', label: '站点名', sortable: false },
          { name: 'type', label: '类型', format: val => ComponentType.getItemText(val), sortable: false },
          { name: 'bloodType', label: '采血类型', format: val => BloodType.getItemText(val), sortable: false },
          { name: 'collectType', label: '采血方式', sortable: false, format: val => CollectMethods.getItemText(val) },
          { name: 'workTime', label: '工作时间', sortable: false, field: row => `${row.workTimeStart} - ${row.workTimeEnd}` },
          { name: 'traffic', label: '交通', sortable: false },
          { name: 'careServices', label: '关怀服务', sortable: false, format: val => this.getText(val) },
          { name: 'state', label: '状态' },
          { name: 'operate', label: '操作', sortable: false }
        ],
        pagination: {
          page: 1,
          rowsPerPage: 20,
          rowsNumber: 0,
          sortBy: '',
          descending: true
        },
        dataFilters: null
      },
      dialogs: {
        edit: {
          show: false,
          editModel: null,
          mode: 'add'
        }
      }
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    onSave () {
      this.dialogs.edit.show = false
      this.search()
    },
    getText (val) {
      const content = JSON.parse(val)
      return `${content.wifi ? 'wifi' : ''}${(content.wifi && content.food) ? '/' : ''}${content.food ? '餐食' : ''}${(content.food && content.souvenir) ? '/' : ''}${content.souvenir ? '纪念品' : ''}`
    },
    onMainRequest ({ pagination }) {
      this.search({
        filters: this.main.dataFilters,
        pagination: pagination
      })
    },
    reset () {
      utils.reset(this.filters.model)
    },
    async search (searchParams) {
      const mainParams = this.buildMainParams(searchParams)
      const result = await this.$$api.bis.get(`/collectPoint/page?pageSize=${mainParams.page.pageSize}&pageNum=${mainParams.page.pageNum}&name=${this.filters.model.name ? this.filters.model.name : ''}`)
      result.notifyIfFail()
      try {
        if (result.success) {
          const resultData = result.data.data
          const pageTotal = result.data.data === undefined ? 0 : result.data.data.length
          result.data = {
            data: resultData,
            pageNum: mainParams.page.pageNum,
            pageTotal: pageTotal
          }
          this.updateMain(mainParams, result)
        }
      } catch (error) {
        result.data = {
          data: null,
          pageNum: mainParams.page.pageNum,
          pageTotal: 0
        }
        this.updateMain(mainParams, result)
      }
    },
    onResetFilters () {
      this.reset()
    },
    onSubmintFilters () {
      this.search()
    },
    add () {
      this.dialogs.edit = Object.assign({}, {
        show: true,
        editModel: null,
        mode: 'add'
      })
    },
    editRow (row) {
      this.dialogs.edit = Object.assign({}, {
        show: true,
        editModel: Object.assign({}, row),
        mode: 'edit'
      })
    },
    editState (row) {
      this.$q.dialog({
        message: `<span style="font-weight: 700">确认${row.state ? '停用' : '启用'}该站点吗?</span>`,
        cancel: { color: 'grey' },
        html: true,
        ok: { color: 'blue' },
        focus: 'cancel'
      }).onOk(async () => {
        const params = {
          id: row.id,
          state: Number(!row.state)
        }
        const result = await this.$$api.bis.put('/collectPoint/operate', params)
        result.notify(result.success ? '修改成功' : null)
        this.search()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.operate-btn {
  font-family: blod;
  font-size: 14px;
  margin: 5px 10px;
  color: rgb(24,144,255);
}
</style>
